import ModalComp from 'Components/common/Modal/Modal.tsx'
import TextAreaAttribute from 'Components/attributes/TextAreaAttribute/TextArea.tsx'
import styles from './SavedForLaterModal.module.less'
import Button from 'antd/lib/button'
import { ATTRIBUTE_TYPES } from 'Constants/attributes.constants.ts'
import { useCallback, useState } from 'react'

export type SaveForLaterModalProps = {
    getVisibility: () => boolean
    onCancel: () => void
    onConfirm: (payload?: { comment: string }) => Promise<void>
}

export const SaveForLaterModal: React.FC<SaveForLaterModalProps> = props => {
    const [saveForLaterValue, setSaveForLaterValue] = useState<string | undefined>('')

    const handleCancel = useCallback(() => {
        setSaveForLaterValue('')
        props.onCancel()
    }, [props])

    const handleConfirm = useCallback(() => {
        props.onConfirm({
            comment: saveForLaterValue || '',
        })
        setSaveForLaterValue('')
    }, [props, saveForLaterValue])

    return (
        <ModalComp
            visible={props.getVisibility()}
            modalHeader={<div className={'modal-header'}>Save Task for Later</div>}
            closable={false}
            onCancel={handleCancel}
            modalFooter={
                <div className={styles.modalFooter}>
                    <Button onClick={handleCancel}>Cancel</Button>
                    <Button type="primary" onClick={handleConfirm}>
                        Confirm
                    </Button>
                </div>
            }
        >
            <div className={styles.modalContent}>
                <p>Please provide a reason for saving this task for later.</p>
                <TextAreaAttribute
                    id="save-reason"
                    rows={6}
                    type={ATTRIBUTE_TYPES.TEXTAREA}
                    value={saveForLaterValue}
                    onChange={setSaveForLaterValue}
                    placeholder="Enter your reason here..."
                />
            </div>
        </ModalComp>
    )
}
